import { useCallback, useState } from "react";
import { parseDragIds } from "../../../../../utils/drag";

/** Drop-zone state + handlers for the trade buckets. The payload is the
 *  URI-encoded id list written by `setDragIds`. */
export function useDropZone(onDrop: (ids: string[]) => void) {
  const [dragOver, setDragOver] = useState(false);

  const handleDragOver = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      e.dataTransfer.dropEffect = "move";
      if (!dragOver) setDragOver(true);
    },
    [dragOver]
  );

  const handleDragLeave = useCallback((e: React.DragEvent) => {
    if (!e.currentTarget.contains(e.relatedTarget as Node)) {
      setDragOver(false);
    }
  }, []);

  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      setDragOver(false);
      const ids = parseDragIds(e.dataTransfer.getData("text/plain"));
      if (ids.length > 0) onDrop(ids);
    },
    [onDrop]
  );

  return { dragOver, handleDragOver, handleDragLeave, handleDrop };
}
